

<div class="card card-statistics mb-30">
  <div class="card-body">

    <ng-container *ngFor="let item of DataList_Behfa">

      <div class="row">
        <div class="form-group col-md-12" style="padding-right: 20px;padding-left: 20px;" *ngIf="item.type==1" innerHTML="{{item.val}}">
        </div>
      </div>

      <div class="row">
        <div class="form-group col-md-12" style="text-align: center;" *ngIf="item.type==2" >
          <img  style="text-align: center;max-width: 1700px;" src="{{BaseUrl}}File/Behfa/{{this.item.val}}"/>
        </div>
      </div>
    
   
      <div ></div>
    
    </ng-container>

  </div>
</div>